module.exports = __webpack_public_path__ + "img/success_icon.698ecf17.png";